export default "__VITE_ASSET__DsnY8qrR__"